import ButtonGlobal from '@shared/Button'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { DeleteWhiteIco, PlusIcoWhite } from '@modules/CustomIcons'
import { t } from 'i18next'
import { setSelectedRowKeys } from 'store/actions/table'

export function FieldActionsLeft() {
  const { getValues, setValue } = useFormContext()

  const dispatch = useDispatch()
  const selectedRowKeys = useAppSelector((state) => state.table.selectedRowKeys)

  return (
    <>
      <ButtonGlobal
        icon={<PlusIcoWhite />}
        customType="primary"
        onClick={() => {
          const id = getValues('tableList')[getValues('tableList').length - 1]
          const newValues = {
            id: id ? getValues('tableList').length : 0, // ids
            customerInfo: '',
            serialType: '',
            serialNo: '',
            pin: '',
            position: '',
            salary: '',
            phoneNumber: '',
            // code: '',
            email: '',
            passwordPdf: '',
          };
          
          setValue('tableList', [...getValues('tableList'), newValues])
        }}
      >
        {t('salary.addRow')}
      </ButtonGlobal>
      <ButtonGlobal
        icon={<DeleteWhiteIco />}
        customType="danger"
        disabled={
          !('employeeTable' in selectedRowKeys) ||
          selectedRowKeys['employeeTable']?.length === 0
        }
        onClick={() => {
          const newTableList = getValues('tableList').filter(item => !selectedRowKeys['employeeTable'].includes(item.id))
            .map((item, i) => ({ ...item, id: i }))

          setValue('tableList', newTableList);
          dispatch(setSelectedRowKeys([]))
        }}
      >
        {t('salary.deleteRowManual')}
      </ButtonGlobal>
    </>
  )
}
